import React, { useEffect, useState, useContext } from "react";
import { Space, Table, Tag, Input, Button, Row, Col, Modal, message, Tooltip } from "antd";
import AddSubtents from "./AddSubtents";
import Services from "../../network/Services";
import konsole from "../../network/konsole";
import "./Firmpartner.css";
import { UserContext } from "../../App";
import { EditOutlined, DeleteOutlined,ProfileFilled,UserOutlined } from "@ant-design/icons";
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
const { Column, ColumnGroup } = Table;
const { Search } = Input;

export default function Subtents() {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setdata] = useState([]);
  const [assignOptionsList, setAssignOptionsList] = useState([]);
  const [dataSearch, setdataSearch] = useState([]);
  const { setLoader } = useContext(UserContext)
  const [value, setValue] = useState("");
  const [subtenantAddress, setSubtenantAddress] = useState("");
  const [show, setshow] = useState(false)
  const [tab, setTab] = useState([])
  const [userData, setuserdata] = useState({})
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, order: 'asc' });

  const sortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort style={{ color: '#aaa', marginLeft: '4px' }} />;
    return sortConfig.order === 'asc'
      ? <FaSortUp style={{ color: '#720c20', marginLeft: '4px' }} />
      : <FaSortDown style={{ color: '#720c20', marginLeft: '4px' }} />;
  };

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      order: prev.key === key && prev.order === 'asc' ? 'desc' : 'asc'
    }));
  };

  const getSortedData = (data) => {
    if (!sortConfig.key) return data;
    return [...data]?.sort((a, b) => {
      let aVal = a[sortConfig.key] ?? '';
      let bVal = b[sortConfig.key] ?? '';

      if (sortConfig.key === 'subtenantId') {
        return sortConfig.order === 'asc' ? aVal - bVal : bVal - aVal;
      }
      aVal = aVal.toString().toLowerCase();
      bVal = bVal.toString().toLowerCase();
      if (aVal < bVal) return sortConfig.order === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.order === 'asc' ? 1 : -1;
      return 0;
    });
  };

  // paginated data
  const paginatedData = (data) => {
    const start = (currentPage - 1) * pageSize;
    return data?.slice(start, start + pageSize);
  };
  const totalPages = Math.ceil(getSortedData(data)?.length / pageSize);

  const showModal = () => {
    setIsModalVisible(true);
    setshow(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setshow(false)
    setuserdata(null)
  };

  const onSearch = (value) => konsole.log(value);

  const createdBy = null;
  const isActive = true;

  useEffect(() => {
    saveTableData();
  }, []);
  konsole.log("valuecheck", show)

  const saveTableData = () => {
    // setshow(true)
    setLoader(true)
    const Subtenantdetailspromise = Services.getsubtenantdetails(createdBy, isActive);
    Subtenantdetailspromise.then((res) => {
      let len = res.data.data.length
      let totalArray = [];
      totalArray = res.data.data;
      // setTimeout(() => {
        setdata(totalArray);
        setAssignOptionsList(totalArray);
        setLoader(false)
      // }, 4000)
    }).catch((err) => {
      konsole.log("err", err);
      setLoader(false)
    }).finally(() => {
    })
  };

  // const getAddress = (getArrrayData) => {

  // };
  const onClickRow = (data) => {
    showModal(true)
    setuserdata(data)
  }

  const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '14px', background: '#fff', textAlign: 'start', padding: "8px" }
  const dtBodyStyle = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: "8px" }
  const dtBodyStyle2 = { color: '#333', fontSize: '13px', background: '', textAlign: 'center', fontWeight: 100, display: "contents", padding: "8px" }
  return (
    <>
      <Row span={24}>
        <Col span={24}>
          <div style={{ display: "flex", justifyContent: "space-between" }} className="mt-3 ">
            <Col span={12} style={{ display: "flex" }}>
              <div


                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #333",
                  height: "44px",
                  padding: "0 5px",
                  background: "#fff",
                  borderRadius:"2px"
                }}>

                <img className="ms-2" style={{ height: "15px", marginRight: "6px"}} src="/search icon.png" alt="search"/>

                <input
                  type="text"
                  className="form-control newInputs"
                  placeholder="Search for firm"
                  value={value}
                  onChange={(e) => {
                    const currValue = e.target.value;
                    setValue(currValue);

                    let filteredData = currValue
                      ? assignOptionsList?.filter((entry) =>
                        entry.subtenantName
                          ?.toLowerCase()
                          .includes(currValue.toLowerCase())
                      )
                      : assignOptionsList;

                    setdata(filteredData);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    flex: 1,
                    height: "100%",
                    fontSize: "16px",
                    background: "transparent"
                  }}
                />
              </div>
            </Col>
             <Col>
            </Col>
            <Col>
              <Button className="add-user-btn" style={{height:"44px", fontSize:"17px"}} onClick={showModal}>
            <img className="mt-0 me-1" src="/images/AddPlusBtn.svg" style={{height:"17px", width:"17px"}}/><span className="mt-1" style={{fontSize:"14px"}}>Add New</span> </Button>
            </Col>
            {show ? <AddSubtents
              title="Basic Modal"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              tableData={saveTableData}
              subtenantAddress={setSubtenantAddress}
              userData={userData}
            /> : <></>}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>


          <div style={{ border: '1px solid #ddd', marginTop: '12px' }}>
            <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
              <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: "Open Sans, sans-serif", fontSize: '13px' }}>
                <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
                  <tr>
                    <th style={dtHeaderStyle}>Actions</th>
                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('subtenantId')}>
                      Firm Id {sortIcon('subtenantId')}
                    </th>
                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('subtenantName')}>
                      Firm Name {sortIcon('subtenantName')}
                    </th>
                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('addressValue')}>
                      Location {sortIcon('addressValue')}
                    </th>
                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }}>Subscriptions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData(getSortedData(data))?.length > 0 ? paginatedData(getSortedData(data))?.map((record) => (
                    <tr key={record.userId}>
                      <td style={dtBodyStyle2}>
                        <div style={{ display: 'flex', justifyContent: "space-evenly", alignItems: 'start',padding:"1rem" }}>
                          <Tooltip title="Click here to edit staff details">
                            <EditOutlined
                              style={{ color: '#4a90d9', fontSize: '16px', cursor: 'pointer' }}
                              onClick={() => onClickRow(record)}
                            />
                          </Tooltip>
                        </div>
                      </td>
                      <td style={dtBodyStyle}>{record?.subtenantId}</td>
                      <Tooltip title="Click here to edit staff details">
                        <td style={dtBodyStyle}>
                          <span style={{ color: '#333', fontWeight: 500, cursor: 'pointer', display: "contents" }} onClick={() => onClickRow(record)}>
                            {record.subtenantName}
                          </span>
                        </td>
                      </Tooltip>
                      <td style={dtBodyStyle}>
                        <Tooltip title={record?.addressValue}>
                          <div style={{
                            maxWidth: '250px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            cursor: 'pointer',
                          }}>
                            <span style={{
                              display: 'contents',
                              color: '#333',
                              fontWeight: 500
                            }}>
                              {record.address?.addressLine1}
                            </span>
                          </div>
                        </Tooltip>
                      </td>
                      <td style={dtBodyStyle}>-</td>
                    </tr>
                  )) : (
                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No matching records found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #ddd', background: '#fff' }}>
              <span style={{ fontSize: '13px', color: '#555' }}>
                Showing {Math.min((currentPage - 1) * pageSize + 1, getSortedData(data)?.length)} to {Math.min(currentPage * pageSize, getSortedData(data)?.length)} of {getSortedData(data)?.length} entries
              </span>

              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {/* Prev */}
                <button
                  onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                  style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}
                >‹</button>

                {/* Page numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  ?.filter(p => p === 1 || p === totalPages || (p >= currentPage - 1 && p <= currentPage + 1))
                  ?.reduce((acc, p, i, arr) => {
                    if (i > 0 && p - arr[i - 1] > 1) acc?.push('...');
                    acc.push(p);
                    return acc;
                  }, [])
                  ?.map((p, i) => p === '...'
                    ? <span key={i} style={{ padding: '0 4px', fontSize: '13px' }}>...</span>
                    : <button
                      key={p}
                      onClick={() => setCurrentPage(p)}
                      style={{
                        width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px',
                        background: currentPage === p ? '#720c20' : '#fff',
                        color: currentPage === p ? '#fff' : '#555',
                        cursor: 'pointer', fontSize: '13px'
                      }}
                    >{p}</button>
                  )
                }

                {/* Next */}
                <button
                  onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', color: '#555' }}
                >›</button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
